import type { TFunction } from 'i18next';

import { HomeworkErrorCode } from 'core';

/**
 * Maps the contract's error codes (spec 0012 §4) to user-facing messages.
 * Unknown / network codes fall through to the generic message.
 */
export const getHomeworkErrorText = (t: TFunction, code?: string | null): string => {
  switch (code) {
    case HomeworkErrorCode.NO_ASSIGNMENT:
      return t('homework.errors.noAssignment');
    case HomeworkErrorCode.NOT_GROUP_MEMBER:
      return t('homework.errors.notGroupMember');
    case HomeworkErrorCode.INVALID_INPUT:
      return t('homework.errors.invalidInput');
    case HomeworkErrorCode.INVALID_GITHUB_URL:
      return t('homework.errors.invalidGithubUrl');
    case HomeworkErrorCode.INVALID_FILE:
      return t('homework.errors.invalidFile');
    case HomeworkErrorCode.FILE_TOO_LARGE:
      return t('homework.errors.fileTooLarge');
    case HomeworkErrorCode.ALREADY_SUBMITTED:
      return t('homework.errors.alreadySubmitted');
    case HomeworkErrorCode.INVALID_MARK:
      return t('homework.errors.invalidMark');
    case HomeworkErrorCode.NOT_LESSON_TEACHER:
      return t('homework.errors.notLessonTeacher');
    case HomeworkErrorCode.AI_DISABLED:
      return t('homework.errors.aiDisabled');
    case HomeworkErrorCode.ASSIGNMENT_EXISTS:
      return t('homework.errors.assignmentExists');
    default:
      return t('homework.errors.generic');
  }
};
